/* eslint no-param-reassign: "error" */
import {
  createSlice,
} from '@reduxjs/toolkit';

import type { AuthStateType, ModeAuthType, UserType } from '@/types/domain/user/redux';
import type {
  ActionReducerMapBuilder,
  PayloadAction,
} from '@reduxjs/toolkit';

import { checkSessionError } from '@/errors';

const initialState: AuthStateType = {
  mode: 'loading',
  user: undefined,
};

/**
 * ユーザーSlice
 */
export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    /** モードをセットする */
    setMode: (state, action: PayloadAction<ModeAuthType>) => {
      state.mode = action.payload;
    },
    /** ユーザーをセットする */
    setUser: (state, action: PayloadAction<UserType | undefined>) => {
      state.user = action.payload;
    },
  },
  extraReducers: (b: ActionReducerMapBuilder<AuthStateType>) => {
    b.addMatcher(
      (action: any) => {
        if (action.type && typeof action.type === 'string') {
          const actionType = action.type as string;
          return actionType.endsWith('/rejected');
        }
        return false;
      },
      (state, action) => {
        const { name, message }: { name: string, message: string } = action.error;
        if (checkSessionError(name, message)) {
          state.mode = 'signin';
          state.user = undefined;
        }
      },
    );
  },
});
